import { Link } from "@tanstack/react-router";
import { DotsThree as Ellipsis } from "@phosphor-icons/react";
import { useState } from "react";
import { Drawer } from "@/components/ui/Drawer";
import { BOTTOM_TAB_MORE, BOTTOM_TAB_NAV, type NavItem } from "./nav-config";

/** Mobile bottom tab bar (<768px): Home, Explore, Communities, Marketplace, More. */
export function BottomTabBar({ items = BOTTOM_TAB_NAV, moreItems = BOTTOM_TAB_MORE }: { items?: NavItem[]; moreItems?: NavItem[] }) {
  const [moreOpen, setMoreOpen] = useState(false);

  return (
    <>
      <nav className="fixed inset-x-0 bottom-0 z-40 grid h-14 grid-cols-5 items-center border-t border-border bg-surface-1 pb-[env(safe-area-inset-bottom)] md:hidden">
        {items.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            activeOptions={{ exact: false }}
            className="flex min-w-0 flex-1 flex-col items-center gap-1 overflow-hidden px-0 py-2 text-caption tracking-tight text-text-secondary"
            activeProps={{ className: "text-primary-text!" }}
          >
            <item.icon size={20} weight="regular" />
            <span className="max-w-full truncate">{item.label}</span>
          </Link>
        ))}
        <button
          type="button"
          className="flex min-w-0 flex-1 flex-col items-center gap-1 overflow-hidden px-0 py-2 text-caption tracking-tight text-text-secondary"
          aria-label="More"
          aria-haspopup="dialog"
          aria-expanded={moreOpen}
          onClick={() => setMoreOpen(true)}
        >
          <Ellipsis size={20} weight="regular" />
          <span className="max-w-full truncate">More</span>
        </button>
      </nav>
      <Drawer
        open={moreOpen}
        onClose={() => setMoreOpen(false)}
        title="More"
        side="bottom"
        className="pb-[calc(1.5rem+env(safe-area-inset-bottom))]"
      >
        <nav aria-label="More navigation" className="flex flex-col">
          {moreItems.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              onClick={() => setMoreOpen(false)}
              className="flex h-12 items-center gap-3 rounded-sm px-3 text-body text-text-primary hover:bg-surface-2"
            >
              <item.icon size={20} weight="regular" className="text-text-secondary" />
              {item.label}
            </Link>
          ))}
        </nav>
      </Drawer>
    </>
  );
}
